import { Component, OnInit } from '@angular/core';
//import { Application } from '../../../shared/user.model';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
//import { ErrorHandler } from '../../../shared/ErrorHandler';
//import { Search } from '../../../shared/user.model';
//import {UserService} from '../../../shared/user.service';

@Component({
  selector: 'app-master-display',
  templateUrl: './master-display.component.html',
  styleUrls: ['./master-display.component.css']
})
export class MasterDisplayComponent implements OnInit {
  menusList: any;
  pagesList: any;
  subpageslist: any;
  localurl : any;
 

  constructor(private router: Router, private route: ActivatedRoute) {
   
   }

  ngOnInit() {
    
      //initially
      this.localurl = '/home/masters'

    this.menusList = localStorage.getItem('menuList');
    this.menusList = JSON.parse(this.menusList);
    for (let i = 0; i < this.menusList.length; i++) {
      if (this.menusList[i].KHB_MenuName == 'Administration')
        this.pagesList = this.menusList[i].KHB_PagesList;
    }

    for (let j = 0; j < this.pagesList.length; j++) {
      if (this.pagesList[j].KHB_Page == 'Masters')
        this.subpageslist = this.pagesList[j].KHB_SubPagesModels;
    }


  }

  geturl(url){    
    localStorage.setItem('url',url)    
    this.localurl= localStorage.getItem('url')
    
  }

}



// WEBPACK FOOTER //
// ./src/app/master/master-display/master-display.component.ts